import { useState } from "react";
import { Menu, X } from "lucide-react";
import { nav } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#071D4D]/75 border-b border-[#C0C7D1]/25"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#inicio" data-testid="nav-brand" className="flex items-baseline gap-2">
          <span className="font-serif-display text-xl font-semibold text-white">Yosimar de Paz</span>
          <span className="hidden sm:inline text-xs uppercase tracking-[0.25em] text-[#C0C7D1]">El Compa Yosi</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((item) => (
            <a
              key={item.target}
              href={item.target}
              data-testid={`nav-link-${item.target.slice(1)}`}
              className="nav-link text-sm text-neutral-200"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menú"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden border-t border-[#C0C7D1]/25 bg-[#071D4D]/95 px-5 py-4 flex flex-col gap-4">
          {nav.map((item) => (
            <a
              key={item.target}
              href={item.target}
              data-testid={`nav-mobile-link-${item.target.slice(1)}`}
              className="text-neutral-100 text-base"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
